import { registerLocaleData } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import localeFr from '@angular/common/locales/fr-CA';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from './app.component';
import { BaseComponent } from './components/base/base.component';
import { ClassEnrolmentCardComponent } from "./components/class-enrolment-card/class-enrolment-card.component";
import { ClassroomHeaderComponent } from "./components/classroom-header/classroom-header.component";
//import { ClassroomRecurrenceComponent } from "./components/classroom-recurrence/classroom-recurrence.component";
import { ConfirmationCloseDialogComponent } from "./components/confirmation-close-dialog/confirmation-close-dialog.component";
import { EligibilityCheckerComponent } from './components/eligibility-checker/eligibility-checker.component';
import { EnrollmentEnrolledTabComponent } from "./components/enrollment-enrolled-tab/enrollment-enrolled-tab.component";
import { AdministrativeWorkComponent } from './components/enrolment/administrative-work/administrative-work.component';
import { EnrolmentConfirmationComponent } from './components/enrolment/enrolment-confirmation/enrolment-confirmation.component';
import { EnrolmentLearnerComponent } from "./components/enrolment/enrolment-learner/enrolment-learner.component";
import { EnrolmentRequestOptionsComponent } from "./components/enrolment/enrolment-request-options/enrolment-request-options.component";
import { EnrolmentSubscriptionComponent } from './components/enrolment/enrolment-subscription/enrolment-subscription.component';
import { RecordOfCompletionComponent } from './components/enrolment/record-of-completion/record-of-completion.component';
import { LearnerDetailComponent } from './components/learner-detail/learner-detail.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AccountErrorComponent } from './components/account-error/account-error.component';
import { NotificationsListComponent } from './components/notifications-list/notifications-list.component';
import { SessionTimeoutComponent } from "./components/session-timeout/session-timeout.component";
import { InfoIconComponent } from "./components/shared/info-icon/info-icon.component";
import { SpinnerComponent } from "./components/shared/spinner/spinner-component";
import { WorkerEnrollmentComponent } from "./components/worker-enrollment/worker-enrollment.component";
import { WorkerEnrolmentSummaryComponent } from './components/worker-enrolment-summary/worker-enrolment-summary.component';
import { GlobalModule } from "./global.module";
import { LearnerCertificateStatusComponent } from "./page-components/certificate-status/certificate-status.component";
import { EnrolementSummaryComponent } from './page-components/enrolement-summary/enrolement-summary.component';
//import { PreventionCmsComponent } from "./page-components/prevention-cms/prevention-cms.component";
import { RegisterWorkerRedirectComponent } from './page-components/register-worker-redirect/register-worker-redirect.component';
import { RegistrationRedirectComponent } from "./page-components/registration-redirect/registration-redirect.component";
import { ViewClassroomComponent } from "./page-components/view-classroom/view-classroom.component";
import { WorkerProfileSetupComponent } from './page-components/worker-profile-setup/worker-profile-setup.component';
import { LocalizationModule } from "./translation/localization.module";  
import { FilterSortPopupComponent } from "./components/filter-sort-popup/filter-sort-popup.component";


//@ts-ignore
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

registerLocaleData(localeFr, 'fr-CA')
registerLocaleData(localeFr, 'fr')

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/locales/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,  
    SpinnerComponent,
    InfoIconComponent,    
    SessionTimeoutComponent,
    ConfirmationCloseDialogComponent,
    ViewClassroomComponent,
    ClassroomHeaderComponent, 
 //   ClassroomRecurrenceComponent, 
    ClassEnrolmentCardComponent,  
    NotificationsListComponent,
    LearnerDetailComponent, 
    WorkerEnrollmentComponent,
    WorkerEnrolmentSummaryComponent, 
    EnrolementSummaryComponent,
    EnrollmentEnrolledTabComponent, 
    EnrolmentRequestOptionsComponent,
    EnrolmentLearnerComponent,
    EnrolmentSubscriptionComponent,
    AdministrativeWorkComponent,
    EnrolmentConfirmationComponent,
    EligibilityCheckerComponent, 
    RecordOfCompletionComponent,
    WorkerProfileSetupComponent,
    NotFoundComponent,
    AccountErrorComponent,
    BaseComponent, 
    LearnerCertificateStatusComponent, 
    //PreventionCmsComponent, 
    RegisterWorkerRedirectComponent,
    RegistrationRedirectComponent,
    FilterSortPopupComponent,
  ],
  imports: [GlobalModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    BrowserModule, 
    LocalizationModule.forRoot({ locale_id: 'en' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [provideZoneChangeDetection()],
  bootstrap: [AppComponent],  
})
export class AppModule { }
